import { AvFeedback, AvField, AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import Button from 'js/components/common/Button';
import Icon from 'js/components/common/Icon';
import { makeRequest } from 'js/services/Network';
import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';

const NewBankAccount = ({ page }) => {
  const [accountNumber, setAccountNumber] = useState('');
  const [accountNumberText, setAccountNumberText] = useState('10 digits NUBAN required');
  const [accountName, setAccountName] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [name, setName] = useState('');
  const [requestInProgress, setRequestInProgress] = useState(false);
  const [banks, setBanks] = useState([]);
  const [bankCode, setBankCode] = useState('');
  const [disabled, setDisabled] = useState(true);
  const [error, setError] = useState(null);
  const [bvn, setBvn] = useState('');
  const [currency, setCurrency] = useState('NGN');

  const onSubmitHandler = async () => {
    const bankAccount = page.bank_account || page.bankAccount;

    if (!bankAccount || !bankAccount.isFilledIn) {
      return;
    }

    const response = await makeRequest('save-vfd-account', null, {
      number: bankAccount.number,
      bank_code: bankAccount.bank_code,
      account_name: bankAccount.account_name,

      bvn: bvn,
      currency: currency,
    });

    if (response) {
      bankAccount.setId(response.data.id);
    }

    const closeModal = page.closeModal || page.closeModals;
    closeModal();
  };

  function validateAccount(e) {
    setAccountNumber(e.target.value);
    const bankAccount = page.bank_account || page.bankAccount;
    if (accountNumber.length === 10 && bankCode) {
      setAccountNumberText('validating...')
      makeRequest('validate-account-details', null, {
        number: bankAccount.number,
        bank_code: bankAccount.bank_code,
      }).then(resp => {
        console.log("response: ", resp);
        setAccountNumberText('');
        setAccountName(resp.data.data?.name);
        setName(resp.data.data?.name);
        setBvn(resp.data.data?.bvn);
        setCurrency(resp.data.data?.currency);
      }).catch(error => {
        if (error.response && error.response.data && error.response.data.message) {
          setError("Account does not exist!");
          setAccountNumberText("Account does not exist!");
        } else {
          setError("Account does not exist!");
          setAccountNumberText("Account does not exist!");
        }
      })
    }
  }

  useEffect(async () => {
    // Load banks from API
    setRequestInProgress(true);
    makeRequest('banks')
      .then(response => {
        // If the request was successful, set the mseller
        setBanks(response.data?.bank);
        setRequestInProgress(false);
      })
      .catch(error => {
        setRequestInProgress(false);
        if (error.response && error.response.data && error.response.data.message) {
          setError(error.response.data.message);
        } else {
          setError('Invalid credentials');
        }
        return false;
      });

    return true;
  }, []);

  useEffect(() => {
    setDisabled(!accountNumber || !name || !bankCode || requestInProgress);

    if (page.bank_account) {
      page.bank_account.setNumber(accountNumber);
      page.bank_account.setRoute('vfd');
      page.bank_account.setBankCode(bankCode);
      return;
    }

    page.bankAccount.setNumber(accountNumber);
    page.bankAccount.setRoute('vfd');
    page.bankAccount.setBankCode(bankCode);
  }, [accountNumber, name, bankCode, requestInProgress]);

  return (
    <div className='modal-form'>
      <AvForm onValidSubmit={onSubmitHandler}>
        <h3 className='title'>
          <Icon name='university' className='icon' />
          Add bank account
        </h3>
        <p>Get paid into your bank account as soon as the transaction is complete</p>

        <AvGroup>
          <Label for='account_number'>Bank</Label>
          <AvField
            type='select'
            name='bank_id'
            id='bank'
            required
            onChange={(e) => setBankCode(e.target.value)}
            value={bankCode}
          >
            {requestInProgress ? <option value=''>Loading...</option> : <option value=''>Select bank</option>}
            {banks.map((bank, index) => (
              <option key={`bank-${bank.id}`} value={bank.code}>{bank.name}</option>
            ))}
          </AvField>
          <AvFeedback>Please select your bank</AvFeedback>
        </AvGroup>
        <AvGroup>
          <Label for='account_number'>Account Number</Label>
          <AvInput
            name='number'
            id='account_number'
            onChange={(e) => validateAccount(e)}
            onKeyUp={(e) => validateAccount(e)}
            onKeyDown={(e) => validateAccount(e)}
            onMouseOut={(e) => validateAccount(e)}
            value={accountNumber}
            required
          />
          <Label style={{ float: 'right', fontSize: '12px', color: 'red' }}>{accountNumberText}</Label>
          <AvFeedback>Please enter your bank account number</AvFeedback>
        </AvGroup>

        <AvGroup>
          <Label for='account_number'>Account Name</Label>
          <AvInput
            name='full_name'
            id='full_name'
            // onChange={(e) => setName(e.target.value)}
            value={name || ''}
            readOnly={true}
            required
          />
          <AvFeedback>Please enter your full name</AvFeedback>
        </AvGroup>
        <Button isLoading={isSaving} autoFocus type='submit' disabled={disabled}>
          Add Account
        </Button>
        {error && error !== 'Account does not exist!' && <p className='error'>{error}</p>}
      </AvForm>
    </div>
  );
};

export default NewBankAccount;
